import { BadgeCheck, ShieldCheck } from "lucide-react";

export const BADGE_CONFIG = {
    agentui_verified: { label: "AgentUI Verified", icon: BadgeCheck, className: "bg-blue-100 text-blue-700 border-blue-200" },
    security_verified: { label: "Security Verified", icon: ShieldCheck, className: "bg-green-100 text-green-700 border-green-200" },
};

export const BADGE_KEYS = Object.keys(BADGE_CONFIG);
